import { render } from "./UpdateCircuitModal.vue?vue&type=template&id=cde32b78"
import script from "./UpdateCircuitModal.vue?vue&type=script&lang=js"
export * from "./UpdateCircuitModal.vue?vue&type=script&lang=js"
script.render = render

export default script